<!-- Content (CXOne widget)-->
<div class="w-100 h-100" [hidden]="!dataLoadSuccess">
    <!-- Callback Requests widget shouldn't show the no data error and instead should just show the zero data -->
    <!-- <app-module-error [noData]="true" *ngIf="noData"></app-module-error> -->
    <canvas *ngIf="chartConfig" 
        width="400px"
        height="225px"
        baseChart
        [type]="chartConfig.type"
        [legend]="chartConfig.options.plugins.legend.display"
        [datasets]="chartConfig.data.datasets"
        [labels]="chartConfig.data.labels"
        [options]="chartConfig.options"
        [plugins]="chartConfig.plugins">
    </canvas>
</div>